/* cima-frete-carga.js (06/out/2026)
 * Carrinho/produto com CARGA GRANDE (tag carga:grande) FORA da Grande POA não tem frete — carga
 * grande só viaja no caminhão Cimafer e Correios não leva. Antes, UM item pesado derrubava a
 * cotação do carrinho inteiro e o cliente via só "Não enviamos para este destino".
 * Aqui: quando a cotação por CEP vem VAZIA, perguntamos ao Worker cimafer-frete-poa
 * (POST /api/leves) QUAIS itens bloqueiam e quanto custaria o RESTANTE (Correios, só informativo),
 * e mostramos as saídas: remover o item, retirar na loja (grátis) ou informar CEP da Grande POA.
 * NÃO cria opção de frete: o checkout continua sem frete para a carga grande fora da área.
 * Usado por shipping-calculator.js (Sacola + PDP) e sections/cima-cart.liquid (página /cart).
 */
(function () {
  if (window.cimaFreteCarga) return;
  var API = 'https://cimafer-frete-poa.anderson-74e.workers.dev/api/leves';

  function brl(n) { return 'R$ ' + Number(n).toFixed(2).replace('.', ','); }
  function el(tag, cls, txt) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (txt != null) e.textContent = txt;
    return e;
  }

  function css() {
    if (document.getElementById('cima-fc-css')) return;
    var s = document.createElement('style');
    s.id = 'cima-fc-css';
    s.textContent =
      '.cima-fc{font-family:var(--f-sans,Inter,sans-serif);font-size:14px;line-height:1.45;color:var(--c-ink,#2C2A28);text-align:left}' +
      '.cima-fc__t{margin:0 0 6px;font-weight:700;font-size:14.5px;color:var(--c-red,#9C2A21)}' +
      '.cima-fc__p{margin:0 0 8px;color:var(--c-stone,#5C574F);font-size:13.5px}' +
      '.cima-fc__lista{list-style:none;margin:0 0 10px;padding:0}' +
      '.cima-fc__item{display:flex;align-items:center;justify-content:space-between;gap:10px;padding:8px 0;border-top:1px solid var(--c-line,#E8E6E4)}' +
      '.cima-fc__item:first-child{border-top:0}' +
      '.cima-fc__nome{flex:1;min-width:0;font-size:13.5px;font-weight:600}' +
      '.cima-fc__rm{flex:none;min-height:44px;padding:0 12px;border:1px solid var(--c-red,#9C2A21);background:#fff;color:var(--c-red,#9C2A21);border-radius:4px;font:600 12.5px var(--f-sans,Inter,sans-serif);cursor:pointer}' +
      '.cima-fc__rm:hover{background:var(--c-red,#9C2A21);color:#fff}' +
      '.cima-fc__rm[disabled]{opacity:.6;cursor:default}' +
      '.cima-fc__bloco{margin:10px 0 0;padding:10px 12px;border:1px solid var(--c-line,#E8E6E4);border-radius:6px;background:var(--c-paper,#fff)}' +
      '.cima-fc__bloco h4{margin:0 0 4px;font-size:12px;letter-spacing:.04em;text-transform:uppercase;color:var(--c-stone,#5C574F);font-weight:600}' +
      '.cima-fc__row{display:flex;justify-content:space-between;gap:12px;font-size:14px}' +
      '.cima-fc__row b{font-variant-numeric:tabular-nums}' +
      '.cima-fc__meta{margin:2px 0 0;font-size:12.5px;color:var(--c-stone,#5C574F)}';
    document.head.appendChild(s);
  }

  /** Pergunta ao Worker quais itens bloqueiam. Retorna null se não há carga grande bloqueando
   *  (ou se o Worker não respondeu → quem chama cai na mensagem antiga). */
  async function analisar(opts) {
    var zip = String((opts && opts.zip) || '').replace(/\D/g, '');
    if (zip.length !== 8) return null;
    var itens = [];
    var INC = { tipo: 'incerto', zip: zip };
    if (opts.produto) {
      itens = [{ variant_id: opts.produto.id, quantity: opts.produto.quantity || 1, grams: opts.produto.grams || 0,
        titulo: opts.produto.titulo || 'Este produto', key: null }];
    } else {
      var c = null;
      try { c = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); } catch (e) { return INC; }
      itens = ((c && c.items) || []).map(function (it) {
        return { variant_id: it.variant_id, quantity: it.quantity, grams: it.grams, titulo: it.product_title, key: it.key };
      });
    }
    var ctrl = new AbortController();
    var t = setTimeout(function () { ctrl.abort(); }, 12000);
    try {
      var r = await fetch(API, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, signal: ctrl.signal,
        body: JSON.stringify({ cep: zip, items: itens.map(function (i) { return { variant_id: i.variant_id, quantity: i.quantity, grams: i.grams }; }) }),
      });
      if (!r.ok) return { tipo: 'incerto', zip: zip };
      var d = await r.json();
      if (!d) return { tipo: 'incerto', zip: zip };
      // RISCO ZERO: só afirmamos "não entregamos" quando o Worker tem CERTEZA de que o CEP está fora da área.
      // 'incerto' (provedores de CEP fora do ar) → mensagem neutra, sem dizer que não entregamos.
      if (d.status === 'incerto') return { tipo: 'incerto', zip: zip };
      // dentro da nossa área e a cotação veio vazia = algo falhou (ou > 10 t): NUNCA dizer 'não enviamos'
      if (d.status === 'dentro') return { tipo: 'incerto', zip: zip };
      if (d.status === 'fora' && d.excede_peso && (!Array.isArray(d.bloqueiam) || !d.bloqueiam.length)) {
        return { tipo: 'peso', zip: zip, produto: !!opts.produto, kg: Number(d.kg_total) || 0, limite: Number(d.limite_kg) || 30,
          itens: itens.map(function (i) { return { titulo: i.titulo, quantity: i.quantity, kg: ((Number(i.grams) || 0) * (Number(i.quantity) || 1)) / 1000 }; }) };
      }
      // 'fora' confirmado, sem item bloqueado nem excesso de peso: a cotação vazia é falha de cotação (ex.: Correios), não 'não enviamos'
      if (!Array.isArray(d.bloqueiam) || !d.bloqueiam.length) return INC;
      var bl = {}; d.bloqueiam.forEach(function (v) { bl[String(v)] = 1; });
      // Se TODOS os bloqueados são só "sem Correios" (frágil: piso, louça, vidro/espelho; ou inflamável), a mensagem
      // não pode falar em "material volumoso/pesado" — o motivo é outro (15/out, pedido #1852).
      var sc = {}; (Array.isArray(d.sem_correios) ? d.sem_correios : []).forEach(function (v) { sc[String(v)] = 1; });
      var soSemCorreios = d.bloqueiam.every(function (v) { return sc[String(v)]; });
      var algumSemCorreios = d.bloqueiam.some(function (v) { return sc[String(v)]; });
      return {
        tipo: 'bloqueio',
        motivo: soSemCorreios ? 'correios' : (algumSemCorreios ? 'misto' : 'carga'),
        zip: zip,
        produto: !!opts.produto,
        bloqueiam: itens.filter(function (i) { return bl[String(i.variant_id)]; }),
        temLeves: (d.leves || []).length > 0,
        rates: Array.isArray(d.rates) ? d.rates : [],
      };
    } catch (e) {
      return { tipo: 'incerto', zip: zip };
    } finally {
      clearTimeout(t);
    }
  }

  /** Monta o bloco de explicação + saídas. `onRemovido` roda após remover um item (Sacola: refresh; /cart: reload). */
  function render(an, onRemovido) {
    css();
    var cepFmt = an.zip.replace(/^(\d{5})(\d{3})$/, '$1-$2');
    var box = el('div', 'cima-fc');
    if (an.tipo === 'incerto') {
      box.appendChild(el('p', 'cima-fc__t', 'Não conseguimos confirmar o frete agora'));
      box.appendChild(el('p', 'cima-fc__p', 'Algum serviço de consulta está instável neste momento. Tente calcular de novo em instantes. Se continuar, fale com a gente pelo WhatsApp ou retire na loja.'));
      return box;
    }
    if (an.tipo === 'peso') {
      var kgf = function (n) { return Number(n).toFixed(n >= 10 ? 0 : 1).replace('.', ','); };
      box.appendChild(el('p', 'cima-fc__t', 'Este pedido passa do limite de peso da entrega'));
      box.appendChild(el('p', 'cima-fc__p',
        'O pedido pesa cerca de ' + kgf(an.kg) + ' kg e, para o CEP ' + cepFmt + ', só enviamos pelos Correios até ' + an.limite +
        ' kg por pedido. Material pesado vai só no caminhão da Cimafer, em Porto Alegre e região.'));
      var ul2 = el('ul', 'cima-fc__lista');
      an.itens.forEach(function (it) {
        var li = el('li', 'cima-fc__item');
        li.appendChild(el('span', 'cima-fc__nome', (it.quantity > 1 ? it.quantity + '× ' : '') + it.titulo + ' · ' + kgf(it.kg) + ' kg'));
        ul2.appendChild(li);
      });
      box.appendChild(ul2);
      var sd = el('div', 'cima-fc__bloco');
      sd.appendChild(el('h4', null, 'O que você pode fazer'));
      sd.appendChild(el('p', 'cima-fc__meta', 'Reduza a quantidade para ficar até ' + an.limite + ' kg e calcule de novo — ou divida em mais de um pedido.'));
      var rr = el('div', 'cima-fc__row');
      rr.appendChild(el('span', null, 'Retirar na loja · Porto Alegre')); rr.appendChild(el('b', null, 'Grátis'));
      sd.appendChild(rr);
      sd.appendChild(el('p', 'cima-fc__meta', 'Av. Dr. Carlos Barbosa, 726 · pronta em ~2h · escolha “Retirada” no checkout.'));
      box.appendChild(sd);
      return box;
    }
    var plural = an.bloqueiam.length > 1;

    if (an.produto) {
      box.appendChild(el('p', 'cima-fc__t', 'Este produto só tem entrega em Porto Alegre e região'));
      box.appendChild(el('p', 'cima-fc__p', an.motivo === 'correios'
        ? 'Este item não vai pelos Correios (material frágil ou de transporte restrito), então só entregamos pela entrega própria da Cimafer — não enviamos para o CEP ' + cepFmt + '.'
        : 'Por ser material volumoso/pesado, ele viaja só no caminhão da Cimafer — não enviamos pelos Correios para o CEP ' + cepFmt + '.'));
    } else {
      box.appendChild(el('p', 'cima-fc__t',
        (plural ? 'Estes itens só têm' : 'Este item só tem') + ' entrega em Porto Alegre e região'));
      box.appendChild(el('p', 'cima-fc__p',
        'Para o CEP ' + cepFmt + ' não conseguimos entregar ' + (plural ? 'os itens abaixo' : 'o item abaixo') +
        (an.motivo === 'correios'
          ? ' (material frágil ou de transporte restrito: não vai pelos Correios, só pela entrega própria da Cimafer).'
          : an.motivo === 'misto'
            ? ' (material volumoso/pesado, frágil ou de transporte restrito: só pela entrega própria da Cimafer, não vai pelos Correios).'
            : ' (material volumoso/pesado, só no caminhão da Cimafer).') +
        ' Por isso a sacola ficou sem frete:'));
      var ul = el('ul', 'cima-fc__lista');
      an.bloqueiam.forEach(function (it) {
        var li = el('li', 'cima-fc__item');
        li.appendChild(el('span', 'cima-fc__nome', (it.quantity > 1 ? it.quantity + '× ' : '') + it.titulo));
        if (it.key && onRemovido) {
          var b = el('button', 'cima-fc__rm', 'Remover');
          b.type = 'button';
          b.setAttribute('aria-label', 'Remover ' + it.titulo + ' da sacola');
          b.addEventListener('click', function () {
            b.disabled = true; b.textContent = 'Removendo…';
            fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: it.key, quantity: 0 }) })
              .then(function (r) { if (!r.ok) throw new Error('change'); return r.json(); })
              .then(function () { onRemovido(); })
              .catch(function () { b.disabled = false; b.textContent = 'Remover'; });
          });
          li.appendChild(b);
        }
        ul.appendChild(li);
      });
      box.appendChild(ul);

      if (an.temLeves) {
        var bl = el('div', 'cima-fc__bloco');
        if (an.rates.length) {
          bl.appendChild(el('h4', null, 'O restante da sacola, sem ' + (plural ? 'esses itens' : 'esse item')));
          an.rates.forEach(function (r) {
            var row = el('div', 'cima-fc__row');
            row.appendChild(el('span', null, r.name + (r.description ? ' · ' + r.description : '')));
            row.appendChild(el('b', null, brl(r.price)));
            bl.appendChild(row);
          });
          bl.appendChild(el('p', 'cima-fc__meta', 'Valor estimado só dos itens que podem ser enviados — remova ' + (plural ? 'os itens acima' : 'o item acima') + ' para finalizar com este frete.'));
        } else {
          bl.appendChild(el('h4', null, 'O restante da sacola'));
          bl.appendChild(el('p', 'cima-fc__meta', 'Não conseguimos cotar o frete dos demais produtos para este CEP (peso ou volume acima do limite dos Correios). Retire na loja ou fale com a gente.'));
        }
        box.appendChild(bl);
      }
    }

    var saidas = el('div', 'cima-fc__bloco');
    saidas.appendChild(el('h4', null, 'O que você pode fazer'));
    var r1 = el('div', 'cima-fc__row');
    r1.appendChild(el('span', null, 'Retirar na loja · Porto Alegre'));
    r1.appendChild(el('b', null, 'Grátis'));
    saidas.appendChild(r1);
    saidas.appendChild(el('p', 'cima-fc__meta', 'Av. Dr. Carlos Barbosa, 726 · pronta em ~2h · escolha “Retirada” no checkout.'));
    saidas.appendChild(el('p', 'cima-fc__meta', 'Ou informe um CEP de Porto Alegre, Viamão ou Guaíba dentro da nossa área de entrega.'));
    box.appendChild(saidas);
    return box;
  }

  window.cimaFreteCarga = { analisar: analisar, render: render };
})();
